import * as React from 'react';

import { IGhSiteGateData } from './gh-site-gate.data';
import { IGhSiteGateProps } from './gh-site-gate.props.autogenerated';
import { isSiteGateUnlocked, getSiteGateCookieName } from '../utilities/site-gate.util';

export interface IGhSiteGateViewProps extends IGhSiteGateProps<IGhSiteGateData> {
    isUnlocked: boolean;
    heading: string;
    buttonText: string;
    errorMessage: string;
    siteGatePassword: string;
    cookieName: string;
}

class GhSiteGate extends React.PureComponent<IGhSiteGateProps<IGhSiteGateData>> {
    public render(): JSX.Element | null {
        // Disable site gate in CMS editing/preview mode
        const params = this.props.context.request.params;
        if (params?.isEditor || params?.isPreview) {
            return null;
        }

        const siteGatePassword = this.props.context.app.config.siteGatePassword;
        if (!siteGatePassword) {
            return null;
        }

        const isUnlocked = isSiteGateUnlocked(siteGatePassword, this.props.context.request.cookies);

        const viewProps: IGhSiteGateViewProps = {
            ...this.props,
            isUnlocked,
            heading: this.props.config.heading || 'This site requires an access code',
            buttonText: this.props.config.buttonText || 'Enter',
            errorMessage: this.props.config.errorMessage || 'Incorrect code, please try again',
            siteGatePassword,
            cookieName: getSiteGateCookieName()
        };

        return this.props.renderView(viewProps) as React.ReactElement;
    }
}

export default GhSiteGate;
